let apiUrl = ''
let apiWeb = ''

switch (process.env.NODE_ENV) {
  case 'production':
    apiUrl = 'https://app.i200.cn'
    apiWeb = 'https://webapi.i200.cn/v0'
    break
  case 'testing':
    apiUrl = 'http://register.fe.yuanbei.biz'
    apiWeb = 'http://pre-webapi.i200.cn/v0'
    break
  case 'development':
    apiUrl = 'http://app.i200.cn'
    apiWeb = 'http://pre-webapi3.i200.cn/v0'
    break
}

export {
  apiUrl,
  apiWeb
}



// WEBPACK FOOTER //
// ./src/config/net.js